import type { V1Care } from '../../../lib/v1';

/** Distinct colour for regular absence bars (not used by any care status). */
export const ABSENCE_COLOR = '#7c3aed';

/** Distinct colour for Pause absence bars — teal, clearly separate from purple. */
export const PAUSE_COLOR = '#0d9488';

/** Brand-Pink für Aufgaben-Deadline-Marker. */
export const TASK_COLOR = '#AF007C';

/** Blau für Verordnungs-Termin-Marker (Batch-12 — Verordnungsmanagement). */
export const VERORDNUNG_COLOR = '#2563eb';

/**
 * Deckkraft für Vertragspausen — sie liegen in derselben Zeile ÜBER den
 * Betreuungs-Balken, deren Text lesbar bleiben muss.
 */
export const OVERLAY_OPACITY = 0.4;

/**
 * Zeile der Krankenhaus-Abwesenheiten (0 = Betreuungen). Die Jahresübersicht
 * hat damit höchstens zwei Zeilen.
 */
export const ABSENCE_ROW = 1;

/** Leicht transparente Aufgaben-/Verordnungs-Marker (eigenes Band). */
export const MARKER_OPACITY = 0.7;

export const STATUS_TONE: Record<number, 'success' | 'warning' | 'neutral' | 'brand' | 'error' | 'blue'> = {
  0: 'blue',
  1: 'neutral',
  2: 'success',
  3: 'warning',
  4: 'neutral',
};

export interface CareRow extends V1Care {
  bk_name?: string | null;
  pb_name?: string | null;
}

export interface TimelineBar {
  care: CareRow;
  left: number;
  width: number;
  row: number;
  label: string;
  statusLabel: string;
}

/** Absence bar — Vertragspause über den Betreuungen (Zeile 0), sonst Zeile 1. */
export interface AbsenceTimelineBar {
  id: number;
  left: number;
  width: number;
  row: number;
  /** Translated/display label. */
  grund: string;
  /** Raw canonical grund value from the API (e.g. 'Pause', 'Urlaub', 'Krankenhaus'). */
  grundRaw: string;
  tooltip: string;
}

/** Eine Aufgabe/Todo mit Deadline (zieldatum) — T1: in der Jahresübersicht. */
export interface TimelineTask {
  id: number;
  titel?: string | null;
  zieldatum?: string | null;
  status?: number | null;
}

/** Deadline-Marker (Diamant) im oberen Band der Timeline. */
export interface TaskMarker {
  id: number;
  left: number;
  label: string;
  tooltip: string;
  done: boolean;
}

/** Batch-12: Verordnung mit Termin (+ optionaler Erinnerung) in der Timeline. */
export interface TimelineVerordnung {
  id: number;
  titel?: string | null;
  termin?: string | null;
  erinnerung_tage?: number | null;
}
